export default __webpack_public_path__ + "images/a506173973edcd69446f83dc05c97f61-maintaining_a_sense_of_self.svg";